// this is broken off from authService to avoid circular dependency in $api and authService
App.service('authServiceHelpers', ($cookies, $timeout, USER_TYPES, $rootScope) => {
  return {
    isDoctor() {
      return $cookies.get('userType') == 'Doctor'
    },
    isRN() {
      return $cookies.get('userType') == 'RegisteredNurse'
    },
    isNP() {
      return $cookies.get('userType') == 'NursePracticioner'
    },
    isPA() {
      return $cookies.get('userType') == 'PhysicianAssistant'
    },
    isMA() {
      return $cookies.get('userType') == 'MedicalAssistant'
    },
    isStaff() {
      return $cookies.get('userType') == 'Staff'
    },
    isUserAuthorized() {
      $timeout( () => {
        return $cookies.get('auth') !== undefined
      })
    },
    isPatientable() {
      return $cookies.get('patientable')
    },
    getUserAuthorization() {
      return {
        auth: $cookies.get('auth'),
        type: $cookies.get('userType'),
        name: $cookies.get('name'),
        subdomain: $cookies.get('subdomain')
      }
    },
    isAuthenticatedWithOAuth() {
      return !!$cookies.get('oauth.token_type')
    },
    getUserAuthorizationHeader() {
      const authToken = this.getAuth()
      const tokenType = this.getTokenType()
      if (authToken && tokenType) {
        return `${tokenType} ${authToken}`
      } else {
        return authToken
      }
    },
    getTokenType() {
      if ($rootScope.embedded) {
        return "Bearer"
      }

      return $cookies.get('oauth.token_type')
    },
    getAuth() {
      if ($rootScope.embedded) {
        return $rootScope.embedded_auth_token
      }

      var auth = $cookies.get('auth')
      if (auth) {
        return auth
      } else if ($rootScope.impersonationSessionId || $rootScope.impersonated) {
        return undefined
      } else { // e.g. appt booking via the iFrame
        return $rootScope.remember_token
      }
    },
    getUserType() {
      return $cookies.get('userType')
    },
    getUserId() {
      return $cookies.get('provider_id')
    },
    getMinApptLength() {
      return $cookies.get('min_appt_length')
    },
    getUserSubdomain() {
      if ($rootScope.embedded) {
        return $rootScope.embedded_subdomain
      } else {
        const cookieSubdomain = $cookies.get('subdomain')
        if ($rootScope.subdomain && cookieSubdomain !== $rootScope.subdomain) {
          // This happens when the user has impersonated in other tab to another institution,
          // or when the subdomain cookie expired while this tab stayed open.
          // In this case we refresh the page to avoid inconsistencies.
          document.location.reload()
        }
        return cookieSubdomain || $rootScope.subdomain
      }
    },
    getInstitutionId() {
      return $cookies.get('institution_id')
    },
    getUserName() {
      return $cookies.get('name')
    },
    getUserEmail() {
      return $cookies.get('email')
    },
    getUserImageUrl() {
      return $cookies.get('image')
    },
    getLocationId(){
      if ($rootScope.embedded) {
        return $rootScope.embedded_location_id
      } else {
        const locationId = $cookies.get('location_id')
        return locationId === 'null' ? undefined : locationId
      }
    },
    impersonated() {
      return !!$cookies.get('impersonated')
    },
    impersonationSessionId() {
      return $cookies.get('impersonationSessionId')
    },
    isProvider() {
      return USER_TYPES.provider_types.indexOf($cookies.get('userType')) != -1
    },
    isStaffOrNurse() {
      return USER_TYPES.staff_types.indexOf($cookies.get('userType')) != -1
    }
  }
})
